const usePermissionConfig = () => {
  return {
    /*
    * 款式号
    * 控制：跳转生产信息编辑
    * 跳转路由名称：ProductionDemandProductionEdit
    * */
    EDIT: 'OPS-PRODUCTION-DEMAND-PRODUCTION-EDIT',
    /*
    * 提交
    * 控制：提交生产信息
    * 跳转路由名称：
    * */
    SUBMIT: 'OPS-PRODUCTION-DEMAND-PRODUCTION-SUBMIT',
  };
};

export default usePermissionConfig;
